module.exports = __webpack_public_path__ + "img/mikolaj-auth.87dd677a.png";